import { io } from "socket.io-client";

let socketInstance = null;
let bedDetailAction = null;
let wardDetailAction = null;
let bedIdAction = null;
let patientDataAction = null;
let deviceVitalDataAction = null;
let alarmDataAction = null;
let notificationDataAction = null;

let vInterval = null;
let mInterval = null;
let aInterval = null;

export const setBedDetailsAction = (bdAction) => {
    bedDetailAction = bdAction;
}

export const setWardDetailAction = (wdAction) => {
    wardDetailAction = wdAction;
}

export const setBedIdAction = (bIdAction) => {
    bedIdAction = bIdAction;
}

export const setPatientDataAction = (pdAction) => {
    patientDataAction = pdAction;
}

export const setDeviceVitalDataAction = (ddAction) => {
    deviceVitalDataAction = ddAction;
}

export const setAlarmDataAction = (adAction) => {
    alarmDataAction = adAction;
}

export const setNotificationDataAction = (ndAction) => {
    notificationDataAction = ndAction;
}

export const openSocketConnection = () => {

    console.log("opening connection");
    if (socketInstance === null) {
        console.log("creating socket");
        // socketInstance = io("http://15.206.207.63:8080", {
        socketInstance = io("http://3.109.221.46:8080", {

            "extraHeaders": {
                "Access-Control-Allow-Origin": "*",
                "channelName": "hospital_1"
            },
            transports: ['websocket']
        });

    } else if (socketInstance.connected === false) {
        socketInstance.connect();
        // socketInstance.open();
    }

    produceMonitor();
    produceVentilator();
    Alarmproduce();
    // handleMessages();
}

export const closeSocketConnection = () => {
    console.log("closing connection");
    socketInstance.close();

    clearInterval(mInterval);
    clearInterval(vInterval);
    clearInterval(aInterval);
}

const handleMessages = () => {
    if (socketInstance === null) {
        console.log("socketInstance is null");
        return;
    }

    // socketInstance.on('message', (msg) => {
    //     console.log("socket message: " + msg);

    //     // if (bedDetailAction) bedDetailAction(JSON.parse(msg));
    //     if (bedIdAction) bedIdAction(JSON.parse(msg));
    // });

    /** from API */
    socketInstance.on("ward_details", (msg) => {
        console.log("socket ward_details: " + msg);
        if (wardDetailAction) wardDetailAction(JSON.parse(msg));
    });

    socketInstance.on("patient_data", (msg) => {
        console.log("socket patient_data: " + msg);
        if (bedIdAction) bedIdAction(JSON.parse(msg));
        if (patientDataAction) patientDataAction(JSON.parse(msg))
    });

    socketInstance.on("device_vitals_data", (msg) => {
        console.log("socket device_data: " + msg);
        if (bedIdAction) bedIdAction(JSON.parse(msg));
        if (deviceVitalDataAction) deviceVitalDataAction(JSON.parse(msg));
    });

    socketInstance.on("device_alarms_data", (msg) => {
        console.log("socket alarm_data: " + msg);
        if (alarmDataAction) alarmDataAction(JSON.parse(msg));
    });

    socketInstance.on("notification_data", (msg) => {
        console.log("socket notification_data: " + msg);
        if (notificationDataAction) notificationDataAction(JSON.parse(msg));
    });
}

let i = 0;
const mparameters = {
    "rr": {
        "unit": "b/min",
        "alarm": {
            "low": 12,
            "high": 20
        }
    },
    "hr": {
        "unit": "b/min",
        "alarm": {
            "low": 60,
            "high": 100
        }
    },
    "spo2": {
        "unit": "%",
        "alarm": {
            "low": 95,
            "high": 101
        }
    },
    "temp": {
        "unit": "F",
        "alarm": {
            "low": 96,
            "high": 100
        }
    },
    "bpLow": {
        "unit": "mmHg",
        "alarm": {
            "low": 60,
            "high": 90
        }
    },
    "bpHigh": {
        "unit": "mmHg",
        "alarm": {
            "low": 90,
            "high": 140
        }
    }
}

const vParameters = {
    "mve": {
        "unit": "b/min",
        "alarm": {
            "low": 96,
            "high": 100
        }
    },
    "pressure": {
        "unit": "cmh2o",
        "alarm": {
            "low": 96,
            "high": 100
        }
    },
    "fio2": {
        "unit": "%",
        "alarm": {
            "low": 96,
            "high": 100
        }
    },
    "peep": {
        "unit": "cmh2o",
        "alarm": {
            "low": 96,
            "high": 100
        }
    },
    "tidalVolume": {
        "unit": "ml",
        "alarm": {
            "low": 96,
            "high": 100
        }
    }
}

const produceMonitor = async () => {
    let i = 0
    if (!mInterval) {
        mInterval = setInterval(async () => {
            try {
                // send a message to the configured topic with
                // the key and value formed from the current value of `i`
                const rr_array = [10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22]
                const hr_array = [58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93]
                const spo2_array = [92, 93, 94, 95, 96, 97, 98, 99, 100]
                const temp_array = [92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102]
                const bp_low_array = [61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80]
                const bp_high_array = [96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125]

                var raw = {
                    bed_name: 'Bed1',
                    monitor_name: "PM1",
                    rr: rr_array[Math.floor(Math.random() * rr_array.length)],
                    hr: hr_array[Math.floor(Math.random() * hr_array.length)],
                    spo2: spo2_array[Math.floor(Math.random() * spo2_array.length)],
                    temp: temp_array[Math.floor(Math.random() * temp_array.length)],
                    bpLow: bp_low_array[Math.floor(Math.random() * bp_low_array.length)],
                    bpHigh: bp_high_array[Math.floor(Math.random() * bp_high_array.length)]
                }

                let data = {
                    hospitalId: 1,
                    wardId: 1,
                    bedId: '1',
                    deviceId: 'deviceId',
                    dongleId: 'dongle-00001',
                    deviceType: 'MONITOR',
                    channelName: 'device_vitals_data',
                    vitals: []
                }

                for (const [key, value] of Object.entries(mparameters)) {

                    const status = (raw[key] < value.alarm.low) || raw[key] > value.alarm.high ? "CRITICAL" : "NORMAL"

                    const x = {
                        "name": key,
                        "unit": value.unit,
                        "data": [{
                            "value": raw[key],
                            "status": status,
                            "time": new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' })
                        }]
                    }

                    data['vitals'].push(x)
                }
                let value = JSON.stringify(data);

                // console.log("data: ", data);
                deviceVitalDataAction(data);

                // if the message is written successfully, log it and increment `i`
                console.log("writes: ", i)
                i++
            } catch (err) {
                console.error("could not write message " + err)
            }
        }, 1000);
    }
}

const produceVentilator = async () => {
    let i = 0
    if (!vInterval) {
        vInterval = setInterval(async () => {
            try {

                const mve_array = [55, 56, 57, 58, 59, 60, 61, 62, 63, 64]
                const pressure_array = [71, 72, 73, 74, 75, 76, 77, 78, 79, 80]
                const fio2_array = [90, 91, 92, 93, 94, 95, 96, 97, 98, 99]
                const peep_array = [35, 36, 37, 38, 39, 40]
                const tidal_volume_array = [76, 77, 78, 79, 80, 81, 82, 83, 84, 85]

                var raw = {

                    bed_name: 1,
                    ventilator_name: 1,
                    mve: mve_array[Math.floor(Math.random() * mve_array.length)],
                    fio2: fio2_array[Math.floor(Math.random() * fio2_array.length)],
                    pressure: pressure_array[Math.floor(Math.random() * pressure_array.length)],
                    peep: peep_array[Math.floor(Math.random() * peep_array.length)],
                    tidalVolume: tidal_volume_array[Math.floor(Math.random() * tidal_volume_array.length)],
                }

                let data = {
                    hospitalId: 1,
                    wardId: 1,
                    bedId: '1',
                    deviceId: 'deviceId',
                    dongleId: 'dongle-00001',
                    deviceType: 'VENTILATOR',
                    channelName: 'device_vitals_data',
                    vitals: []
                }

                for (const [key, value] of Object.entries(vParameters)) {
                    let status = "NORMAL";
                    let x = {
                        "name": key,
                        "unit": value.unit,
                        "data": [{
                            "value": raw[key],
                            "status": status,
                            "time": new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' })
                        }]
                    }

                    data['vitals'].push(x);
                }

                deviceVitalDataAction(data);

                // if the message is written successfully, log it and increment `i`
                console.log("writes venti: ", i)
                i++
            } catch (err) {
                console.error("could not write message " + err)
            }
        }, 1000);
    }
}

const Alarmproduce = async () => {

    let i = 0
    aInterval = setInterval(async () => {

        try {
            // send a message to the configured topic with
            // the key and value formed from the current value of `i`
            const alarm_name_array = ['High Systolic BP', 'High Diastolic BP', 'High RR', 'High HR', 'High Temperature', 'Low Systolic BP', 'Low Diastolic BP', 'Low RR', 'Low HR', 'Low Temperature', 'Low Spo2']
            const alarm_value_array = [142, 97, 24, 112, 102.8, 84, 89, 59, 11, 57, 95.8, 61]
            const priority = ['HIGH', 'HIGH', 'HIGH', 'HIGH', 'HIGH', 'LOW', 'LOW', 'LOW', 'LOW', 'LOW', 'LOW']

            const idx = Math.floor(Math.random() * alarm_name_array.length);

            var raw = {
                bed_name: 1,
                monitor_name: 1,
                name: alarm_name_array[idx],
                value: alarm_value_array[idx],
                priority: priority[idx],
            }

            let data = {
                hospitalId: 1,
                wardId: 1,
                bedId: 1,
                deviceId: 1,
                dongleId: 'dongle-00001',
                deviceType: 'MONITOR',
                alarms: [{
                    id: 1,
                    name: raw.name,
                    value: raw.value,
                    priority: raw.priority,
                    rank: 1,
                    "time": new Date().toLocaleString('en-US', { timeZone: 'Asia/Kolkata' })
                }]
            }

            alarmDataAction(data);

            // if the message is written successfully, log it and increment `i`
            console.log("a writes: ", i);
            i++;
        } catch (err) {
            console.error("could not write message " + err)
        }
    }, 10000)
};